export default "__VITE_ASSET__CVYxfF9n__"